<template>
  <span v-if="terms">
    By continuing you agree to the
    <a class="pop-auth__link" href="https://www.pageoptimizer.pro/terms-of-service" target="_blank" rel="noopener">Terms of Service</a> and
    <a class="pop-auth__link" href="https://pageoptimizer.pro/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a>.
  </span>
</template>

<script>
// Footer line under the signup card (the Turnstile widget sits in the form, so no captcha notice here).
export default {
  name: 'AuthTermsFooter',
  props: { terms: { type: Boolean, default: true } },
}
</script>
